import React from 'react';
// import {Modal} from 'react-spaceship-web'
import {Link} from "react-router-dom";
import {Helper} from './Helper';
import {Form2FileUpload, Modal} from "react-spaceship-web";

export default class Document extends React.Component {
	constructor(props) {
		super(props);
		let _state = {};
		window.Route.on({
			'/v2/settings/documents': () => {
				_state = {
					mode: 'list',
					document: {
						type: ''
					},
					documents: [],
					document_id: '',
				};
			},
			'/v2/settings/documents/new': () => {
				_state = {
					mode: 'create',
					document: {
						type: ''
					},
					documents: [],
					document_id: '',
				};
			},
			'/v2/settings/documents/:document_id': (params) => {
				_state = {
					mode: 'view',
					params: params,
					document: {
						type: ''
					},
					documents: [],
					document_id: '',
				};
			},
			'/v2/settings/documents/:document_id/edit': (params) => {
				_state = {
					mode: 'edit',
					params: params,
					document: {
						type: ''
					},
					documents: [],
					document_id: '',
				};
			}
		}).match();
		_state.qs = window.Global.getAllQueryStrings();
		_state.is_table_loading = true;
		this.state = _state;

	}

	componentDidUpdate(prevProps, prevState) {

		if (this.props.location.pathname !== prevProps.location.pathname) {
			// console.log(this.props.location);
			window.Route.on({
				'/v2/settings/documents': () => {
					this.setState({
						mode: 'list',
						document: {
							type: ''
						},
						documents: [],
						document_id: '',
						qs: Helper.getQueryStringParams(this.props.location.search),
						is_table_loading: true,
					}, () => {
						this.fetch();
					})
				},
				'/v2/settings/documents/new': () => {
					this.setState({
						mode: 'create',
						document: {
							type: ''
						},
						documents: [],
						document_id: '',
						is_table_loading: true,
					})
				},
				'/v2/settings/documents/:document_id': (params) => {
					this.setState({
						mode: 'view',
						params: params,
						document: {
							type: ''
						},
						documents: [],
						document_id: '',
						is_table_loading: true,
					}, () => {
						this.view();
					});
				},
				'/v2/settings/documents/:document_id/edit': (params) => {
					this.setState({
						mode: 'edit',
						params: params,
						document: {
							type: ''
						},
						documents: [],
						document_id: '',
						is_table_loading: true,
					}, () => {
						this.edit();
					});
				}
			}).match();
		} else if (this.props.location.search !== prevProps.location.search) {
			this.setState({
				qs: Helper.getQueryStringParams(this.props.location.search),
				is_table_loading: true,
			}, () => {
				this.fetch();
			})
		}
	}

	prepare() {

	}

	componentDidMount() {
		if (this.state.mode === 'list') {
			this.prepare();
			this.fetch();
			return;
		}
		if (this.state.mode === 'edit') {
			this.edit();
		}
		if (this.state.mode === 'view') {
			this.view();
		}
	}

	edit() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/document',
			data: {document_id: this.state.params.document_id},
			done: (response) => {
				// response = response.data;
				let document = response['document'][0];
				// console.log(response);
				this.setState({
					document: document,
					document_id: document.id,
					is_table_loading: false,
				}, () => {
					window.$(this.$parent).find('form').form2('setup');
					this.prepare();

					if (document
						&& document.meta_data
						&& document.meta_data.meta_data_1_image
					) {
						document.meta_data_1_image_size = document.meta_data.meta_data_1_image.size
					}

					window.$(this.$parent).find('form').form2('init', {
						data: document
					});

					window.$(this.$parent).find('form').form2('submit', {
						method: 'PUT',
						url: process.env.REACT_APP_DOMAIN + '/api/document',
						beforeSent: function (object) {
							return object;
						},
						loadingButton: window.$(this.$parent).find('#submit-button'),
						onSuccess: (response) => {
							window.Global.messageTop({
								type: 'positive',
								message: 'บันทึกข้อมูลสำเร็จ'
							});
							// this.context.router.transitionTo('/v2/settings/documents?type=' + response.document.type);
							// window.location = '/v2/settings/documents/' +  this.state.document.id;
							this.props.history.push({
								pathname: '/v2/settings/documents/' + this.state.document.id,
								search: null,
								state: null
							});
						}
					});
				});
			},
			fail: () => {

			}
		});
	}

	view() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/document',
			data: {document_id: this.state.params.document_id},
			done: (response) => {
				let document = response.document[0];
				this.setState({
					document: document,
					document_id: document.id,
					is_table_loading: false,
				});
			},
			fail: () => {

			}
		});
	}

	fetch() {
		let $search = window.$(this.$parent).find('#Search_root');
		window.Search.init({
			$node: $search
		});

		let data = this.state.qs;
		data.all = 'true';
		data.auto_create = 'true';

		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/document',
			data: data,
			done: (response) => {
				window.$(this.$parent).find('.table').tablePagination({
					disableContent: true,
					size: response.document.length,
					count: response.count,
					onClickPagination: (p) => {
						let qs = window.Global.getAllQueryStrings();
						qs.page = p;
						this.props.history.push(window.Global.getQueryStringLinkFromObject(qs));
					}
				});
				this.setState({
					is_table_loading: false,
					documents: response.document
				});
			},
			fail: () => {

			}
		});
	}

	renderList() {
		return (
			<div ref={(ref) => {
				this.$parent = ref;
			}} className="main ui container">
				<SettingMenu current={4}/>
				<div id="HeaderTop_root">
					<div className="flex row wrap">
						<div className="ui huge breadcrumb">
							<h2 className="active section ui dividing header" href="/v2/settings/documents">ตั้งค่าระบบ
								:
								ฟอร์มการพิมพ์เอกสาร</h2>
						</div>
					</div>
				</div>
				<div className="flex row padded" style={{marginTop: '1em'}}>
					<div className="col-lg-4 col-xs-16 padded">
						<div className="box">
							<DocumentTypeMenu type={this.state.qs && this.state.qs.type ? this.state.qs.type : false}/>
						</div>
					</div>
					<div className="col-lg-12 col-xs-16 padded">
						<div className="ui basic table can click Table_root td-top-xs" style={{margin: 0}}>
							<div className="thead">
								<div className="tr">
									<div className="th span8">ชื่อฟอร์ม</div>
									<div className="th span4">ขนาด</div>
									<div className="th span4">สถานะ</div>
								</div>
							</div>
							<div className="tbody">
								{
									this.state.is_table_loading ?
										<div className="tr">
											<div className="td center aligned">
												<div className="ui active centered inline small loader"/>
											</div>
										</div>
										: null
								}
								{
									!this.state.is_table_loading
									&& this.state.documents.length === 0 ?
										<div className="tr">
											<div className="td center aligned">
												ไม่มีข้อมูล
											</div>
										</div>
										: null
								}
								{
									!this.state.is_table_loading ?
										this.state.documents.map((document, i) => {
											return (
												<Link key={i}
												      className='tr'
												      to={'/v2/settings/documents/' + document.id}>
													<div className='td span8'>
														<div><b>{document.name}</b></div>
													</div>
													<div className='td span4'>
														<div>
															{
																!document.page_width ?
																	<b>A4</b> :
																	<b>{document.page_width} * {document.page_height}</b>
															}
														</div>
													</div>
													<div className='td span4'>
														<div>
															{
																!document.is_disabled ?
																	<div className="ui label big green">ใช้งาน</div> :
																	<div className="ui label big yellow">ไม่ใช้งาน</div>
															}
														</div>
													</div>
												</Link>
											);
										})
										: null
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	renderView() {
		// console.log(this.state);
		return (
			<div ref={(ref) => {
				this.$parent = ref;
			}} className="main ui container">
				<div id="HeaderTop_root">
					<div className="flex row wrap">
						<div className="ui huge breadcrumb" style={{margin: '0.3em 1.3rem 0 0'}}>
							<Link id="header" className="active section"
							      to={"/v2/settings/documents?type=" + this.state.document.type}>ฟอร์มการพิมพ์เอกสาร</Link>
							<span className="divider" style={{margin: '0 1rem'}}>/</span>
							<div className="active section">
								{this.state.document ? this.state.document.name : ''}
							</div>
						</div>
						<div className={"right floated"}>
							{
								this.state.document
								&& this.state.document.id ?
									<Link to={'/v2/settings/documents/' + this.state.document.id + '/edit'}
									      className={"ui button blue"}>
										แก้ไข
									</Link>
									: null
							}
						</div>
					</div>
				</div>
				<div
					className={this.state.is_table_loading ? "ui form tall padded stacked segment loading" : "ui form tall padded stacked segment"}>
					<div className="flex row padded wrap two column computer">
						<div className="column field">
							<h3 className="ui dividing header">ตั้งค่าเอกสาร</h3>
							<div className="field required">
								<label>ชื่อฟอร์ม</label>
								{this.state.document ? this.state.document.name : ''}
							</div>
							<div className="field required">
								<label>ข้อความเพิ่มเติมบนเอกสาร</label>
								<div
									style={{whiteSpace: 'pre-line'}}>{this.state.document && this.state.document.remark ? this.state.document.remark : '-'}</div>
							</div>
						</div>
						<div className="column field">
							<h3 className="ui dividing header">อื่นๆ</h3>
							<div>
								{
									this.state.document && this.state.document.is_disabled !== undefined ?
										<div className="inline field">
											{
												this.state.document && this.state.document.is_disabled
													?
													<>
														<i className={"times icon"} style={{marginRight: 5, color: 'red'}}/>
														<p>ปิดใช้งาน</p>
													</>
													:
													<>
														<i className={"check icon"} style={{marginRight: 5, color: 'green'}}/>
														<p>ใช้ฟอร์มนี้</p>
													</>
											}
										</div>
										: null
								}
							</div>
							<div>
								{
									this.state.document && this.state.document.is_default !== undefined ?
										<div className="inline field">
											{
												this.state.document && !this.state.document.is_default ?
													<i className={"times icon"} style={{marginRight: 5, color: 'red'}}/>
													:
													<i className={"check icon"} style={{marginRight: 5, color: 'green'}}/>
											}
											<p>เป็นค่าเริ่มต้น</p>
										</div>
										: null
								}
							</div>
						</div>
						<div className="column field">
							<label>ลายเซ็น</label>
							{
								!this.state.is_table_loading
								&& this.state.document
								&& this.state.document.document_signature
								&& this.state.document.document_signature.length > 0 ?
									<div className="flex row padded wrap three column computer"
									     id={"product_price_condition_permission"}
									     style={{marginTop: 0}}>
										{
											this.state.document.document_signature.map((document_signature, document_signature_i) => {
												return (
													<div className="column"
													     style={{
														     position: 'relative',
														     marginTop: document_signature_i > 2 ? 15 : 0
													     }}
													     key={document_signature_i}>
														<div className="field">
															<div
																id={"show-label"}
																style={{
																	display: 'flex',
																	alignItems: 'center',
																	flex: 1,
																	color: '#000',
																	cursor: 'pointer'
																}}
															>
																<div style={{
																	maxWidth: '100%',
																	minWidth: 120,
																	margin: 'auto'
																}}>
																	<div className={"signature-img"}
																	     style={{
																		     textAlign: 'center',
																		     marginBottom: 5
																	     }}>
																		{
																			document_signature.signature
																			&& document_signature.signature.file_upload ?
																				<img
																					src={document_signature.signature.file_upload.url}
																					alt={"Signature"}/>
																				:
																				<img
																					src={process.env.REACT_APP_DOMAIN + "/storage/image.png"}
																					alt={"Signature"}/>
																		}
																	</div>

																	<div
																		className={"flex row center-xs"}>
																		{document_signature.line_1 ||
																			<span style={{
																				maxWidth: '100%',
																				width: 80,
																				height: 5
																			}}/>
																		}
																	</div>
																	{
																		document_signature.line_2 ?
																			<div
																				className={"flex row center-xs"}>{document_signature.line_2}</div>
																			: null
																	}
																</div>
															</div>
															<div className="center-xs flex row"
															     style={{marginTop: 5}}>
																<button
																	className={"ui button icon circular mini"}
																	style={{marginRight: 10}}
																	onClick={() => {
																		window.Global.reactToDom(
																			window.$('body'),
																			<DocumentAddSignatureModal
																				mode={"edit"}
																				document_signature={document_signature}
																				document_id={this.state.document.id}
																				onSuccess={() => {
																					this.setState({
																						is_table_loading: true
																					}, () => {
																						this.view()
																					})
																				}}
																			/>
																		);
																	}}
																	data-tooltip="แก้ไข"
																	data-inverted={true}
																>
																	<i className={"icon edit"}/>
																</button>
																<button
																	className={"ui button icon circular mini"}
																	data-tooltip="ยกเลิก"
																	data-inverted={true}
																	onClick={(e) => {
																		let _button = window.$(e.target).parents('.item').find('.button');
																		_button.addClass('loading');
																		_button.attr('disabled', true);
																		window.Global.confirm({
																			title: 'ยกเลิก',
																			content: window.Handlebars.compile('<form class="ui form" autocomplete="off">\n\t<p>โปรดยืนยันยกเลิก การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>\n\t<div class="ui error message"></div>\n</form>')({}),
																			cancel_text: 'ไม่ดำเนินการ',
																			approve_text: 'ยกเลิกเลายเซ็น',
																			onShowToSetupForm: ($modal) => {
																				$modal.find('form').form2('setup');
																				$modal.find('form').form2('submit', {
																					method: 'DELETE',
																					url: process.env.REACT_APP_DOMAIN + '/api/v1/document_signature',
																					loadingButton: $modal.find('.button'),
																					beforeSent: (data) => {
																						data.document_signature_id = document_signature.id;
																						return data;
																					},
																					onSuccess: (response) => {
																						$modal.modal('hide');
																						window.Global.messageTop({
																							type: 'positive',
																							message: 'ยกเลิกเรียบร้อย'
																						});
																						this.view();
																						_button.removeClass('loading');
																						_button.attr('disabled', false);
																					}
																				});
																			},
																			onDeny: () => {
																				_button.removeClass('loading');
																				_button.attr('disabled', false);
																			}
																		});
																	}}
																>
																	<i className={"icon times"}/>
																</button>
															</div>
														</div>
													</div>
												);
											})
										}
									</div>
									: null
							}
							{
								!this.state.is_table_loading
								&& this.state.document
								&& this.state.document.document_signature
								&& this.state.document.document_signature.length === 0 ?
									<p>ไม่มีลายเซ็น</p>
									: null
							}

							<div className={"mt-5"}>
								<button className={"ui button blue"}
								        onClick={() => {
									        window.Global.reactToDom(
										        window.$('body'),
										        <DocumentAddSignatureModal
											        mode={"create"}
											        document_id={this.state.document.id}
											        onSuccess={() => {
												        this.setState({
													        is_table_loading: true
												        }, () => {
													        this.view()
												        })
											        }}
										        />
									        );
								        }}
								>
									เพิ่มลายเซ็น
								</button>
							</div>
						</div>
						<div className={'column field'}>
							<label htmlFor="">รูปเพิ่มเติม (เช่น QR CODE ท้ายบิล)</label>
							{
								this.state.document
								&& this.state.document.meta_data
								&& this.state.document.meta_data.meta_data_1_image
									? (
										<div>
											<img src={this.state.document.meta_data.meta_data_1_image.url} alt={''} className={'w-[180px]'}/>
											<div className={'mt-2 whitespace-pre'}>{this.state.document.meta_data.meta_data_1_image.title}</div>
										</div>
									)
									: null
							}
						</div>
					</div>
				</div>
			</div>
		);
	}

	render() {
		if (this.state.mode === 'view') return this.renderView();
		if (this.state.mode === 'list') return this.renderList();

		return (
			<div ref={(ref) => {
				this.$parent = ref;
			}} className="main ui container">
				<div id="HeaderTop_root">
					<div className="flex row wrap">
						<div className="ui huge breadcrumb" style={{margin: '0.3em 1.3rem 0 0'}}>
							<Link id="header" className="active section"
							      to={"/v2/settings/documents"}>ฟอร์มการพิมพ์เอกสาร</Link>
							{
								this.state.document
								&& this.state.document.id ?
									<>
										<span className="divider" style={{margin: '0 1rem'}}>/</span>
										<Link id="header" className="section"
										      to={"/v2/settings/documents/" + this.state.document.id}>{this.state.document ? this.state.document.name : ''}</Link>
										<span className="divider" style={{margin: '0 1rem'}}>/</span>
										<div className="active section">
											แก้ไข
										</div>
									</>
									: null
							}

						</div>
					</div>
				</div>
				<form
					className={this.state.is_table_loading ? "ui form tall padded stacked segment loading" : "ui form tall padded stacked segment"}
					autoComplete="off">
					<h3 className="ui dividing header">ตั้งค่าเอกสาร</h3>
					<div className="flex row padded wrap two column computer">
						<div className="column field">
							<div className="field required">
								<label>ชื่อฟอร์ม</label>
								<input type="text"
								       name="name"/>
								<input type="hidden" name="document_id"
								       defaultValue={this.state.document ? this.state.document.id : ''}/>
							</div>
						</div>
						<div className="column field">
							<label>ข้อความเพิ่มเติมบนเอกสาร</label>
							<textarea name="remark" cols="30" rows="10"/>
						</div>
						<div className="column field">
							<h4 className="ui dividing header">อื่นๆ</h4>
							<div>
								<div className="inline field">
									<div className="ui checkbox" data-form2_setup={true}>
										<input id="is_disabled"
										       type="checkbox"
										       tabIndex="0"
										       className="hidden"
										       name="is_disabled"/>
										<label htmlFor="is_disabled">ปิดใช้งาน</label>
									</div>
								</div>
							</div>
							<div className={'mt-2'}>
								<div className="inline field">
									<div className="ui checkbox" data-form2_setup={true}>
										<input id="is_default"
										       type="checkbox"
										       tabIndex="0"
										       className="hidden"
										       name="is_default"/>
										<label htmlFor="is_default">เป็นค่าเริ่มต้น</label>
									</div>
								</div>
							</div>
						</div>
						<div className={'column field'}>
							<div className="field">
								<label htmlFor="">รูปเพิ่มเติม 1 (เช่น QR CODE ท้ายบิล)</label>
								<Form2FileUpload
									upload_type="single_image"
									input_name="meta_data_1_image"
									removeInputName="meta_data_1_image"
									isCanRemove={true}
									value={
										this.state.document
										&& this.state.document.meta_data
										&& this.state.document.meta_data.meta_data_1_image
											? this.state.document.meta_data.meta_data_1_image.filename
											: ''
									}
									image_url={
										this.state.document
										&& this.state.document.meta_data
										&& this.state.document.meta_data.meta_data_1_image
											? this.state.document.meta_data.meta_data_1_image.url
											: ''
									}
									key_file_data="file_upload"
									width="180px"
									height="180px"
									mode={"view"}
									url={process.env.REACT_APP_DOMAIN + "/api/file/upload?type=upload"}
									// onRemove={this.state.signature && this.state.signature.file_upload ? () => {
									// 	return false;
									// } : false}
									onUploadDone={(file) => {
										// console.log(file);
										return true;
									}}
								/>
							</div>
							<div className="field">
								<label>รูปเพิ่มเติม 1 - ขนาด</label>
								<div className="field">
									<select className="ui dropdown"
									        name="meta_data_1_image_size"
									        data-form2_setup="">
										<option value="30%">เล็ก</option>
										<option value="50%">กลาง</option>
										<option value="80%">ใหญ่</option>
									</select>
								</div>
							</div>
							<div className="field">
								<label>รูปเพิ่มเติม 1 - ข้อความอธิบาย</label>
								<textarea name="meta_data_1_image_title"
								          defaultValue={
									          this.state.document
									          && this.state.document.meta_data
									          && this.state.document.meta_data.meta_data_1_image
										          ? this.state.document.meta_data.meta_data_1_image.title
										          : ''
								          }
								/>
							</div>
						</div>
					</div>
					<br/>
					<div className="ui grid">
						<div className="column row">
							<div className="column">
								<div className="ui error message"/>
								<div className="flex row">
									<div className="right floated">
										<Link id="cancelButton"
										      to={this.state.mode === 'edit' ?
											      "/v2/settings/documents/" + this.state.document.id :
											      "/v2/settings/documents"
										      }
										      className="ui button">ยกเลิก</Link>
										<button id="submit-button"
										        className="ui primary button"
										        type="submit">บันทึกข้อมูล
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		);
	}

	void() {
		window.Global.confirm({
			title: 'ยืนยันยกเลิก',
			content: 'โปรดยืนยันยกเลิก การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้',
			cancel_text: 'ยกเลิก',
			approve_text: 'ตกลง',
			onApprove: ($modal) => {
				$modal.find('.button.approve').addClass('loading');
				window.Global.ajax({
					method: 'DELETE',
					url: '/api/relationship/branch',
					data: {
						document_id: this.state.document.id
					},
					done: (response) => {
						$modal.find('.button.approve').removeClass('loading');
						if (response.error) {
							window.Global.messageTop({
								type: 'negative',
								message: response['message'][0]['error_message'],
								delay: 15000
							});
							return;
						}
						if (!response.success) return false;
						window.Global.messageTop({
							type: 'positive',
							message: 'ยกเลิกสำเร็จ'
						});
						window.router.navigate("/v2/settings/documents?id=" + this.state.relationship_id);
					}
				});
			}
		});
	}
}

class DocumentTypeMenu extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.props ? {...this.props} : {};
		this.state.types = [
			{
				'title': 'ใบเสนอราคา',
				'type': 'sale_order_quotation',
			},
			{
				'title': 'ใบขายสินค้า',
				'type': 'sale_order',
			},
			{
				'title': 'ใบแจ้งหนี้/ใบวางบิล',
				'type': 'sale_order_invoice',
			},
			{
				'title': 'เอกสารการเงิน',
				'type': 'payment',
			},
			{
				'title': 'ใบซื้อสินค้า',
				'type': 'purchase_order',
			},
			{
				'title': 'ใบส่งสินค้า/ใบคืนสินค้า/ใบรับสินค้า',
				'type': 'shipment',
			},
			{
				'title': 'เงินเดือน',
				'type': 'pay_slip',
			},
			{
				'title': 'ใบโอนย้ายสินค้าระหว่างคลัง',
				'type': 'stock_transfer',
			},
			{
				'title': 'ใบปรับสินค้าคงคลัง',
				'type': 'stock_adjustment',
			},
			{
				'title': 'ใบผลิตสินค้า',
				'type': 'bom_adjustment',
			},
			{
				'title': 'ใบลดหนี้/ใบเพิ่มหนี้',
				'type': 'debit_credit_note',
			},
			{
				'title': 'เงินทดรองจ่าย',
				'type': 'cash_advance',
			},
			{
				'title': 'เคลียร์เงินทดรอง',
				'type': 'clear_cash_advance',
			},
			{
				'title': 'ใบปะหน้าส่งพัสดุ',
				'type': 'cover_shipping',
			}
		];
	}

	componentDidMount() {

	}

	render() {
		return (
			<div>
				<h3>ประเภทเอกสาร</h3>
				<div className="ui secondary vertical menu" style={{width: 'initial'}}>
					{
						this.state.types.map((type, i) => {
							return (
								<Link key={i}
								      className={this.props.type === type.type ? "item active" : "item"}
								      to={"/v2/settings/documents?type=" + type.type}>{type.title}
								</Link>
							)
						})
					}
				</div>
			</div>
		)
	}
}

class SettingMenu extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.props ? {...this.props} : {};
	}

	componentDidMount() {

	}

	render() {
		return (
			<div className="ui menu flex row wrap Setting_menu">
				<a className={this.state.current === 1 ? "item active" : "item"}
				   href="/setting/company_info">ข้อมูลบริษัท</a>
				<a className={this.state.current === 2 ? "item active" : "item"} href="/setting/branch">สาขา</a>
				<a className={this.state.current === 3 ? "item active" : "item"}
				   href="/setting/running_number?is_default=1">เลขที่รันเอกสาร</a>
				<a className={this.state.current === 4 ? "item active" : "item"}
				   href="/v2/settings/documents?type=sale_order">ฟอร์มการพิมพ์เอกสาร</a>
				<a className={this.state.current === 5 ? "item active" : "item"} href="/setting/uom">หน่วยนับ (UOM)</a>
				<a className={this.state.current === 6 ? "item active" : "item"} href="/setting/stock">คลังสินค้า</a>
				<a className={this.state.current === 7 ? "item active" : "item"} href="/setting/filter">หมวดหมู่</a>
				<a className={this.state.current === 8 ? "item active" : "item"}
				   href="/settings/relationship-generate-qr-code">QR Code ลูกค้า/เจ้าหนี้</a>
			</div>
		)
	}
}

class DocumentAddSignatureModal extends React.Component {
	render() {
		return (
			<div>
				<Modal className="ui modal tiny"
				       closable={false}
				       onShowToSetupForm={($modal) => {
					       this.modal = $modal;
					       this.modal.find('form').form2('setup')
					       this.modal.find('form').form2('submit', {
						       url: process.env.REACT_APP_DOMAIN + '/api/v1/document_signature',
						       method: this.props.mode === 'create' ? 'POST' : 'PUT',
						       loadingButton: this.modal.find('.button.approve'),
						       beforeSent: (data) => {
							       delete data.line_1_self_editor
							       delete data.line_2_self_editor
							       delete data.search
							       return data;
						       },
						       onSuccess: (response) => {
							       window.Global.messageTop({
								       type: 'positive',
								       message: 'เพิ่มลายเซ็นสำเร็จ'
							       });
							       this.props.onSuccess();
							       this.modal.modal('hide')
						       }
					       })
					       this.modal.find('form').find('input[name="signature_id"]').explorer({
						       url: process.env.REACT_APP_DOMAIN + '/api/v1/signature',
						       additionalData: {
							       limit: 10,
							       page: 1
						       },
						       key: 'signature',
						       template: {
							       list: '<a class="item flex row">{{title}} ({{position}})</a>',
							       selected: {
								       text: 'title',
								       value: 'id',
								       placeholder: 'เพิ่มลายเซ็น'
							       }
						       },
						       onSelected: (response) => {
							       let input_line_1 = this.$inputLineEdit1.val();
							       let input_line_2 = this.$inputLineEdit2.val();
							       if (!input_line_1) {
								       this.$inputLine1.val(response.title);
							       }
							       if (!input_line_2) {
								       this.$inputLine2.val(response.position);
							       }
						       }
					       });
					       if (this.props.mode === 'edit' && this.props.document_signature) {
						       if (this.props.document_signature.signature) {
							       this.modal.find('form').find('input[name="signature_id"]').explorer('set value', this.props.document_signature.signature);
						       }
						       this.$inputLine1.val(this.props.document_signature ? this.props.document_signature.line_1 : '');
						       this.$inputLine2.val(this.props.document_signature ? this.props.document_signature.line_2 : '');
					       }
				       }}>
					<div className="header">
						<h2>
							{this.props.mode === 'create' ? "เพิ่มลายเซ็น" : null}
							{this.props.mode === 'edit' ? "แก้ไขลายเซ็น" : null}
						</h2>
					</div>
					<div className="content">
						<form className="ui form">
							{
								this.props.document_id ?
									<input type="hidden" name={"document_id"} value={this.props.document_id}/>
									: null
							}
							{
								this.props.document_signature ?
									<input type="hidden" name={"document_signature_id"}
									       value={this.props.document_signature.id}/>
									: null
							}
							<div className="flex row wrap column one column computer padded">
								<div className="column field">
									<label>ลายเซ็น</label>
									<input type={'text'}
									       name={"signature_id"}
									       defaultValue={this.props.document_signature ? this.props.document_signature.id : ''}
									/>
								</div>
								<div className="column field">
									<label>คำอธิบาย 1</label>
									<input type={'text'}
									       name={"line_1"}
									       ref={(ref) => {
										       this.$inputLine1 = window.$(ref)
									       }}
									       defaultValue={this.props.document_signature ? this.props.document_signature.line_1 : ''}
									       onChange={() => {
										       this.$inputLineEdit1.val('1')
									       }}
									/>
									<input type={'hidden'}
									       name={"line_1_self_editor"}
									       ref={(ref) => {
										       this.$inputLineEdit1 = window.$(ref)
									       }}
									/>
								</div>
								<div className="column field">
									<label>คำอธิบาย 2</label>
									<input type={'text'}
									       name={"line_2"}
									       ref={(ref) => {
										       this.$inputLine2 = window.$(ref)
									       }}
									       defaultValue={this.props.document_signature ? this.props.document_signature.line_2 : ''}
									       onChange={() => {
										       this.$inputLineEdit1.val('2')
									       }}
									/>
									<input type={'hidden'}
									       name={"line_2_self_editor"}
									       ref={(ref) => {
										       this.$inputLineEdit2 = window.$(ref)
									       }}
									/>
								</div>
							</div>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							{
								this.props.mode === 'edit'
								&& this.props.onDelete
									? <div className="ui red button"
									       onClick={() => {
										       this.props.onDelete(this.props.product_price_condition);
									       }
									       }>ลบข้อมูล</div>
									: null
							}
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div className="ui approve green right button">บันทึกข้อมูล</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		);
	}
}
